<template>
  <div id="app" :class="[lang, theme, touch ? 'touch' : 'no-touch', fetching, roll, search, first]" :style="bgColor ? `background-color:#${bgColor}` : ''">
    <AppHeader v-if="!hideChrome"/>
    <scroll-holder container-class="scroll-container" body-class="scroll-body">
      <router-view/>
      <AppFooter v-if="!hideChrome"/>
    </scroll-holder>
    <Search/>
    <div class="fixed-holder"></div>
  </div>
</template>

<script>
import AppHeader from '@/views/common/AppHeader';
import AppFooter from '@/views/common/AppFooter';
import { i18n } from '@/plugins/i18n';
import oax from '@/utils/oax';
import _ from 'lodash';
import Search from '@/views/components/Search.vue';

export default {
  name: 'App',
  components: { Search, AppHeader, AppFooter },
  data() {
    return {
      topStyle: false,
    };
  },
  metaInfo() {
    return {
      title: this.$t('meta.title'),
      meta: [
        { vmid: 'title', content: this.$t('meta.title') },
        { vmid: 'description', content: this.$t('meta.description') },
        { vmid: 'keywords', content: this.$t('meta.keywords') },
        { vmid: 'image', content: `${ process.env.VUE_APP_HOST }/img/og.png` },
        { vmid: 'path', content: this.$route.path.replace(new RegExp(`^/(${i18n.routeMatches()})`), '') },
      ],
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    bgColor() {
      return this.$store.state.bgColor;
    },
    fetching() {
      return this.$store.state.fetchingAsyncData && 'fetching';
    },
    roll() {
      return this.$store.state.browser.scrollDirection === 'down' && 'roll'; //&& this.$scroll.getScrollTop() > 0 && 'roll';
    },
    search() {
      return this.$store.state.searchMode && 'search';
    },
    first() {
      return this.$store.state.isFirst && 'first';
    },
    hasSearchData() {
      return this.$route.query.searchData;
    },
    hideChrome() {
      return this.$route.meta.hideChrome;
    },
  },
  watch: {
    async $route(to, from) {
      if (to.params.locale !== from.params.locale) {
        const codes = (await oax.get('/api/code/full', { lang: this.$i18n('lang') })).data;
        this.$store.commit('setCodes', _.forEach(codes, row => row.data = JSON.parse(row.data)));
      }
      if (!to.path.includes('/works/article/')) {
        this.$store.commit('bgColor', '');
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="less">
@import '~@/less/common.less';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.loading { .flex-center; .fix; .lt; .f;
  i { .block; .wh(80);
    border: 3px solid rgba(0, 0, 0, .3);
    border-top-color: #000;
    border-radius: 50%;
    animation: spin 1s ease-in-out infinite;
    .dark & {
      border: 3px solid rgba(255, 255, 255, .3);
      border-top-color: #fff;
    }
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

[scroll-body] { transform: translateY(0); transition: transform .5s cubic-bezier(.59, .01, .28, 1);
  .search & { transform: translateY(260px);
    @media (min-width: @screen-dm-min) {
      transform: translateY(350px);
    }
  }
  .first & { transition-duration: 0s; }
}
</style>
